import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PieVentasDiariasPorEmpresa from '../PieVentasDiariasPorEmpresa/PieVentasDiariasPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaInicioPeriodoMesActualFunc, fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';
import * as actions from '../../../../store/actions/index';

const MultiChartVentasDiariasPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <PieVentasDiariasPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Ventas diarias por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalVentas)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.ventas}
                onChangeViewClick={handleChangeView}
                title={`Gastos del mes por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalVentas)}`}
                height={245}
                width={'100%'}
            />
    )
}

const mapStateToProps = (state) => {
    return {
        ventas: state.multiempresa.ventasDiariasPorEmpresa.ventas,
        totalVentas: state.multiempresa.ventasDiariasPorEmpresa.totalVentas,
        loading: state.multiempresa.ventasDiariasPorEmpresa.loading,
        estaCargado: state.multiempresa.ventasDiariasPorEmpresa.estaCargado,
        estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.ventasDiariasMultiempresa
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
      onLoadChart: () => dispatch(actions.loadVentasDiariasMultiempresa())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartVentasDiariasPorEmpresa);